import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import { transformTranslateFromValues, dateTimeToserver } from "lib/helpers";
import Modal from "components/Modal";
import { TextArea } from "components/form";
import { CkEditorFull } from "components/form";
import { GalleryField } from "components/form";
import { useCore } from "store/core";
import TextFieldSlug from "components/form/TextFieldSlug";
import MyFormComponent from "utils/DynamicEntityTypeFields";
import extractValues from "utils/extractValues";
import MultiselectAdd from "components/form/MultiSelectAdd";
import SearchSelect from "utils/SearchSelect";

export default function Add(props) {
  const core = useCore();

  // test add time for playDate

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{
            translations: {
              fa: {
                title: "",
                slug: "",
                summary: "",
                content: "",
              },
              en: {
                title: null,
                slug: null,
                summary: null,
                content: null,
              },
            },
            channel: null,
            link: "",
            media: null,
            logo: null,
            playDate: "",
          }}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            const result = extractValues(values, ["channel"]);

            await props.submit(result);
            resetForm();
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty }) => (
            <Form>
              <div className='modal-body gap-y-3'>
                <div className='intro-x grid md:grid-cols-2 md:gap-3'>
                  <Field
                    placeholder='عنوان'
                    label='عنوان :'
                    name='translations.fa.title'
                    slugFieldName='translations.fa.slug'
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder='عنوان(en)'
                    label='عنوان (en):'
                    name='translations.en.title'
                    slugFieldName='translations.en.slug'
                    component={TextFieldSlug}
                  />

                  <div className='intro-y'>
                    <Field
                      label='نامک:'
                      name='translations.fa.slug'
                      component={TextField}
                    />
                  </div>
                  <div className='intro-y'>
                    <Field
                      label='نامک انگلیسی:'
                      name='translations.en.slug'
                      component={TextField}
                    />
                  </div>

                  <Field
                    label='خلاصه'
                    name='translations.fa.summary'
                    component={TextArea}
                  />
                  <Field
                    label='خلاصه انگلیسی'
                    name='translations.en.summary'
                    component={TextArea}
                  />
                </div>
                <br />

                <div className='w-full flex justify-between'>
                  <div className='w-full'>
                    <Field
                      label='توضیحات:'
                      name='translations.fa.content'
                      component={CkEditorFull}
                    />
                  </div>
                </div>
                <br />
                <div className='w-full flex justify-between'>
                  <div className='w-full'>
                    <Field
                      label='توضیحات انگلیسی:'
                      name='translations.en.content'
                      component={CkEditorFull}
                    />
                  </div>
                </div>

                <div className='mt-10'>
                  <Field
                    placeholder='لینک'
                    label='لینک:'
                    name='link'
                    component={TextField}
                  />
                  <div className='mt-4'>
                    <Field
                      placeholder='تاریخ پخش'
                      label='تاریخ پخش :'
                      name='playDate'
                      component={PersianDataPicker}
                      hasTime={true}
                    />
                  </div>
                  <div className='mt-4 mb-4'>
                    <Field
                      placeholder='تاریخ و ساعت پایان'
                      label='تاریخ و ساعت پایان:'
                      name='endDate'
                      component={PersianDataPicker}
                      hasTime={true}
                    />
                  </div>
                  <Field
                    label='شبکه:'
                    name='channel'
                    component={SearchSelect}
                    collectionName='channel'
                    searchFields='translations.title'
                    showFields='translations.title'
                  />
                </div>

                <div className='w-full flex justify-between mt-10'>
                  <div className='w-full'>
                    <Field
                      label='مدیا'
                      name='media'
                      dataType='id'
                      component={GalleryField}
                    />
                  </div>
                </div>

                <div className='w-full flex justify-between mt-10'>
                  <div className='w-full'>
                    <Field
                      label='لوگو'
                      name='logo'
                      dataType='id'
                      component={GalleryField}
                    />
                  </div>
                </div>
              </div>

              <div className='modal-footer text-right'>
                <button
                  className='btn btn-primary w-20'
                  type='submit'
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type='button'
                  disabled={isSubmitting}
                  onClick={props.close}
                  className='btn btn-outline-secondary w-20 mr-1'
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
